import './SkeletonLoading.scss';

/**
 * Skeleton card component for loading state
 */
const SkeletonCard = () => (
  <div className="ksq2-browser-panel__skeleton-card">
    <div className="ksq2-browser-panel__skeleton-avatar" />
    <div className="ksq2-browser-panel__skeleton-content">
      <div className="ksq2-browser-panel__skeleton-header">
        <div className="ksq2-browser-panel__skeleton-title" />
        <div className="ksq2-browser-panel__skeleton-date" />
      </div>
      <div className="ksq2-browser-panel__skeleton-memo" />
      <div className="ksq2-browser-panel__skeleton-row">
        <div className="ksq2-browser-panel__skeleton-badge" />
        <div className="ksq2-browser-panel__skeleton-amount" />
      </div>
    </div>
    <div className="ksq2-browser-panel__skeleton-checkbox" />
  </div>
);

interface SkeletonLoadingProps {
  /** Number of skeleton cards to show. Defaults to 6, max 20 */
  count?: number;
}

/**
 * Skeleton loading state component for BrowserPanel
 * Shows placeholder cards while data is being fetched
 * Count can be based on queue counts for better UX
 */
export const SkeletonLoading = ({ count = 6 }: SkeletonLoadingProps) => {
  const cardCount = Math.min(Math.max(count, 1), 20);

  return (
    <div className="ksq2-browser-panel__skeleton-list">
      {Array.from({ length: cardCount }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
};
